import React from 'react'
import { useTranslation } from 'next-i18next'
import { HeroIcons } from '../../../lib/utils/heroIcons'

interface PortfolioCardProps {
  currentPropertiesAmount: number
}

export default function PortfolioCard({
  currentPropertiesAmount,
}: PortfolioCardProps) {
  const { t } = useTranslation('dashboard')

  return (
    <div>
      <div className="relative overflow-hidden rounded-md bg-white">
        <div className="mb-3 flex items-center space-x-4 px-3 pt-3">
          <div className="w-1/6">
            <div className="rounded-md bg-primary p-3">
              <HeroIcons.BuildingOffice2Icon
                className="text-white"
                aria-hidden="true"
              />
            </div>
          </div>
          <div className="w-5/6">
            <div className="flex">
              <div className="flex-grow">
                <div className="text-sm font-medium text-neutralBlack/80">
                  {t('statsCards.portfolioCard.title')}
                </div>
                <div className="text-2xl font-semibold text-neutralBlack">
                  <div className="flex items-baseline text-4xl font-bold">
                    {currentPropertiesAmount}
                    <div className="ml-1 text-sm font-normal">
                      {t('statsCards.portfolioCard.total', {
                        count: currentPropertiesAmount,
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
